module.exports = "html,body,h1,h2,h3,h4,h5 {font-family: \"Raleway\", sans-serif}\nul.multiline-info li div i {\n    position: absolute;\n    right: 0;\n    font-style: normal;\n    color: #FFF;\n    padding: 3px;\n    border-radius: 3px;\n    min-width: 20px;\n    text-align: center;\n}\nul.multiline-info li div i.grey {\n    background: #4D5360;\n}\nul.multiline-info li div.label {\n\n    font-size: 11px;\n    font-weight: normal;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cqm-ns/cqm-ns-monitoring/cqm-ns-monitoring.component.css
// module id = ./src/app/modules/cqm-ns/cqm-ns-monitoring/cqm-ns-monitoring.component.css
// module chunks = main